function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#252F32",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.175 30.139h6.237v1H8.175zM8.175 32.083h6.237v1H8.175zM9.134 34.028h4.318v1H9.134zM11.053 0h1v4.375h-1zM4.337 1.944l.83-.486 2.044 3.587-.83.486zM.019 7.161l.48-.842L4.036 8.39l-.48.842zM18.73 8.39l3.54-2.07.48.841-3.54 2.07zM15.372 5.045l2.043-3.587.83.486-2.042 3.587zM14.412 29.167h-.96v-3.048l.303-.12a6.73 6.73 0 003.536-3.232v-9.341a6.713 6.713 0 00-5.998-3.711 6.713 6.713 0 00-5.997 3.71v9.342a6.73 6.73 0 003.536 3.236l.302.12v3.044h-.96v-2.412a7.694 7.694 0 01-3.79-3.68l-.048-.1v-9.771l.048-.101a7.673 7.673 0 016.91-4.353 7.673 7.673 0 016.908 4.353l.048.101v9.79l-.048.101a7.694 7.694 0 01-3.79 3.66v2.412z"
}));

function SvgAssist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAssist;